import { render, staticRenderFns } from "./RELPassageirosViagem.vue?vue&type=template&id=5fb4b786&"
import script from "./RELPassageirosViagem.vue?vue&type=script&lang=js&"
export * from "./RELPassageirosViagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports